var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ direction: _vm.$vs.rtl ? 'rtl' : 'ltr' }),attrs:{"title":_vm.title}},[_c('feather-icon',{attrs:{"icon":_vm.params.data.projectState === 'DONE' ? 'flag-checkered' : 'circle',"svg-classes":_vm.svgClasses}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }